import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import ServicesGrid from "@/sections/ServicesGrid";
import ProcessTimeline from "@/sections/ProcessTimeline";
import CTABanner from "@/components/CTABanner";
import ContactSection from "@/sections/ContactSection";
import { SERVICES } from "@/data/site";

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  provider: { "@type": "LocalBusiness", name: "DiziTeQ Innovative Solutions", areaServed: "Bengaluru" },
  serviceType: SERVICES.map((s) => s.title),
};

export default function ServicesPage() {
  return (
    <>
      <SEO
        title="Digital Marketing Services Bengaluru"
        description="Website design & development, Local SEO, Google Business Profile optimization, Google Ads, Meta Ads, branding, social media and more — premium services from DiziTeQ Bengaluru."
        path="/services"
        schema={schema}
      />
      <PageHeader
        eyebrow="Our services"
        title="Everything you need to grow"
        highlight="online"
        subtitle="Sixteen premium services across web, SEO, advertising and branding — designed to generate measurable business growth."
      />
      <ServicesGrid showHeader={false} />
      <ProcessTimeline />
      <div className="py-10"><CTABanner /></div>
      <ContactSection showMap={false} />
    </>
  );
}
